import React from "react";
import PropTypes from "prop-types";
import InfoArticle from "components/cart/infoArticle";

/**
 * WarningIndicator
 *
 * Renderizza un singolo warning articolo nel formato e con i colori decisi dalla
 * configurazione backend `config('b2b.warning_display')` (un blocco per tipo:
 * article_warning, out_of_stock).
 *
 * Prop `config` (oggetto): { mode, tag_bg, tag_text }
 *   - mode     : 'none' | 'icon' | 'tag' | 'both'
 *                  none = niente, icon = solo icona+tooltip (storico),
 *                  tag  = solo tag/badge testo completo, both = icona + tag insieme
 *   - tag_bg   : colore di sfondo del tag (CSS); se assente usa il default SCSS
 *   - tag_text : colore del testo del tag (CSS); se assente usa il default SCSS
 * Per retro-compatibilità `config` può anche essere direttamente la stringa del mode.
 *
 * Il componente è volutamente generico (riceve un `value` testuale), così da poter essere
 * usato sia nel carrello/ordine (campi `alert`, `out_of_stock_message`) sia nel grid catalogo
 * (campi `article_warning`, `out_of_stock_message`), che hanno nomi di campo diversi.
 */
const WarningIndicator = ({
  value,
  config,
  iconClassName = "c-cart-item__alert icon icon-alert",
  tagClassName = "c-cart-item__badge c-cart-item__tag-warning",
}) => {
  // config può essere un oggetto { mode, tag_bg, tag_text } oppure (retro-compat) la sola stringa mode
  const mode = (typeof config === "string" ? config : config?.mode) || "both";
  const tagBg = typeof config === "object" ? config?.tag_bg : undefined;
  const tagText = typeof config === "object" ? config?.tag_text : undefined;

  const isEmpty =
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "");

  if (isEmpty || mode === "none") return null;

  const showIcon = mode === "icon" || mode === "both";
  const showTag = mode === "tag" || mode === "both";

  // Colori dal config sovrascrivono i default definiti in SCSS (.c-cart-item__tag-warning)
  const tagStyle = {};
  if (tagBg) tagStyle.backgroundColor = tagBg;
  if (tagText) tagStyle.color = tagText;

  return (
    <>
      {showIcon && (
        <InfoArticle item={value} classIcon={iconClassName} isAlert={true} />
      )}
      {showTag && (
        <span className={tagClassName} style={tagStyle}>
          {value}
        </span>
      )}
    </>
  );
};

WarningIndicator.propTypes = {
  value: PropTypes.string,
  config: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconClassName: PropTypes.string,
  tagClassName: PropTypes.string,
};

export default WarningIndicator;
